.container {
  display: grid;
  gap: 32px;
  padding: 83px 16px 140px;
}

.h2 {
  font-size: var(--font-size-xl);
  font-weight: 700;
  text-align: center;
}

.description {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.icon {
  width: 75px;
  height: 75px;
}

.h1 {
  font-size: var(--font-size-lg);
  font-weight: 700;
  text-align: center;

  > span {
    display: block;
  }
}

.detail {
  font-size: var(--font-size-sm);
  text-align: left;

  > span {
    display: block;
  }
}

.anchor {
  display: inline-block;
  padding: 16px 40px;
  margin-inline: auto;
  color: var(--color-white);
  background-color: var(--color-primary-blue-700);
  border-radius: 3px;

  &:hover {
    background-color: var(--color-primary-blue-500);
  }
}

@media screen and (width >= 600px) {
  .description {
    gap: 16px;
  }

  .h1 {
    font-size: var(--font-size-xxl);
  }

  .detail {
    font-size: var(--font-size-md);
    text-align: center;
  }
}
